import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-4d7faab5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "nav-header-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactiveList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["nav-item", {
        active: item.active
      }]),
      key: index,
      onClick: function ($event) {
        return _ctx.onClickItem(item);
      }
    }, _toDisplayString(item.name), 11, _hoisted_3);
  }), 128))])]);
}